// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-User-Permission-List-List__buttonWrapper--Y7\\+nS{margin-top:2.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonWrapper": "src-User-Permission-List-List__buttonWrapper--Y7+nS"
};
export default ___CSS_LOADER_EXPORT___;
